export const LOGIN_VALUE = "LOGIN_VALUE";
export const LABEL_VALUE = "LABEL_VALUE";
